import { render, staticRenderFns } from "./ScatterEChart.vue?vue&type=template&id=083c1ef4"
import script from "./ScatterEChart.vue?vue&type=script&lang=js"
export * from "./ScatterEChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports